import React from 'react';
import SEO from '../../components/common/SEO';
import Breadcrumbs from '../../components/common/Breadcrumbs';

const Terms = () => {
    return (
        <>
            <SEO 
                title="利用規約｜Stripe請求書CSV一括発行サービス Billwave"
                description="Stripe請求書一括発行クラウド「Billwave」の利用規約です。本サービスの提供条件、利用資格、料金決済、禁止事項、損害賠償、プライバシーポリシーとの連携などに関する契約内容をご確認いただけます。"
                path="/terms"
            />
            <div className="max-w-4xl mx-auto px-4 py-8">
                <Breadcrumbs items={[{ label: '利用規約' }]} />

                <div className="bg-white p-8 rounded-lg shadow border border-gray-100">
                    <h1 className="text-3xl font-bold mb-8 text-center text-gray-900">Billwave利用規約</h1>
                    
                    <div className="space-y-10 text-gray-700 leading-relaxed text-sm sm:text-base">
                        {/* 第1章 総則 */}
                        <section>
                            <h2 className="text-2xl font-bold mb-6 pb-2 border-b-2 border-blue-600 text-gray-900">第1章 総則</h2>
                            
                            <div className="space-y-6">
                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第1条（適用）</h3>
                                    <p>1. 本利用規約（以下「本規約」といいます。）は、株式会社シグナル（以下「当社」といいます。）が提供するクラウド型請求書発行・請求業務支援サービス「Billwave」（以下「本サービス」といいます。）の利用条件を定めるものです。</p>
                                    <p>2. 本サービスを利用するすべての利用者（以下「ユーザー」といいます。）は、本規約に同意したうえで本サービスを利用するものとします。</p>
                                    <p>3. 当社とユーザーとの間の本サービスの利用契約は、ユーザーが本規約に同意し、当社が利用登録を承認した時点で成立するものとします。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第2条（本規約の範囲）</h3>
                                    <p>1. 当社が本サービス上または当社ウェブサイトに掲載する利用方法、ガイドライン、ヘルプ、料金表、各種ポリシーその他本サービスに関するルールは、本規約の一部を構成するものとします。</p>
                                    <p>2. 本規約と前項の定めの内容が異なる場合は、個別に別段の定めがある場合を除き、当該個別の定めが優先して適用されます。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第3条（本規約の変更）</h3>
                                    <p>1. 当社は、法令の改正、本サービスの内容変更その他必要がある場合には、本規約を変更することがあります。</p>
                                    <p>2. 当社は、本規約を変更する場合には、変更内容および効力発生日を本サービス上または当社が適当と判断する方法により事前に周知します。</p>
                                    <p>3. 変更後もユーザーが本サービスの利用を継続した場合、変更後の規約に同意したものとみなします。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第4条（定義）</h3>
                                    <p>本規約において使用する用語は、次の各号に定める意味を有します。</p>
                                    <ul className="list-none space-y-1 ml-4">
                                        <li>1. 「ユーザー」とは、本サービスの利用登録を行い、当社がこれを承認した法人または個人をいいます。</li>
                                        <li>2. 「アカウント」とは、本サービスを利用するために当社が発行する利用資格をいいます。</li>
                                        <li>3. 「管理者」とは、ユーザーを代表して本サービスを管理する権限を有する者をいいます。</li>
                                        <li>4. 「メンバー」とは、管理者により利用を許可された利用者をいいます。</li>
                                        <li>5. 「外部サービス」とは、本サービスと連携して利用される第三者のサービスをいいます。</li>
                                    </ul>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第5条（提供サービス）</h3>
                                    <p>1. 当社は、本サービスにおいて、請求業務を支援するための各種機能およびこれに付随するサービスを提供します。</p>
                                    <p>2. 本サービスの内容、機能、提供条件および利用方法の詳細については、当社が別途定めるものとします。</p>
                                    <p>3. 当社は、本サービスの品質向上その他の目的のため、ユーザーへの事前または事後の通知により、本サービスの内容を追加、変更または終了することがあります。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第6条（取引実績等の掲載）</h3>
                                    <p>1. 当社は、本サービスの利用者その他当社と取引関係にある法人またはその他の事業者について、その商号、法人名または屋号（以下「名称等」といいます。）を、当社との取引実績、導入実績その他当社の営業、広報またはマーケティング活動を目的として、当社のWebサイト、営業資料その他の媒体に掲載することができるものとします。</p>
                                    <p>2. 当社は、前項に基づき名称等を掲載する場合、本サービスの利用の有無、利用期間、利用内容、利用料金その他の取引内容を、利用者の個別の同意なく公表するものではありません。</p>
                                    <p>3. 当社は、利用者から名称等の掲載の停止または削除の申し出を受けた場合、合理的な期間内に当該掲載を停止または削除するものとします。ただし、既に印刷、配布その他の方法により利用者の管理が及ばない媒体については、この限りではありません。</p>
                                    <p>4. 当社は、利用者のロゴ、商標、サービス名称、導入事例、利用者のコメントその他名称等以外の情報を掲載する場合には、別途利用者の同意を得るものとします。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第7条（提供地域および対象）</h3>
                                    <p>1. 本サービスは、日本国内の法人または事業者を主たる対象として提供するものとします。</p>
                                    <p>2. 当社は、EU加盟国その他日本国外の利用者を対象とした積極的なサービス提供または販売活動を行っておりません。</p>
                                    <p>3. 本サービスの提供地域、対象となる利用者その他の提供条件については、当社が別途定める場合があります。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第8条（利用登録）</h3>
                                    <p>1. 本サービスの利用を希望する者は、本規約に同意したうえで、当社所定の方法により利用登録を申請するものとします。</p>
                                    <p>2. 当社は、申請内容を審査し、利用を承認した場合にはアカウントを発行します。</p>
                                    <p>3. 利用登録は、登録情報が真実かつ正確であることを前提とします。</p>
                                    <p>4. ユーザーは、登録情報に変更が生じた場合には、速やかにこれを更新するものとします。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第9条（利用登録の不承認）</h3>
                                    <p>当社は、利用登録の申請者が次の各号のいずれかに該当すると判断した場合、登録申請を承認しないことがあります。</p>
                                    <ul className="list-none space-y-1 ml-4">
                                        <li>1. 虚偽の事項を届け出た場合</li>
                                        <li>2. 本規約に違反したことがある場合</li>
                                        <li>3. 反社会的勢力に該当し、または関与していると認められる場合</li>
                                        <li>4. 当社が提供するサービスの利用停止または契約解除を受けたことがある場合</li>
                                        <li>5. その他、当社が利用登録を適当でないと判断した場合</li>
                                    </ul>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第10条（登録情報の変更）</h3>
                                    <p>1. ユーザーは、名称、電子メールアドレスその他登録情報に変更があった場合には、速やかに当社所定の方法により変更手続きを行うものとします。</p>
                                    <p>2. 前項の変更手続きが行われなかったことによりユーザーに生じた損害について、当社は責任を負いません。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第11条（アカウント管理）</h3>
                                    <p>1. ユーザーは、自己の責任においてアカウントおよびパスワードを適切に管理するものとします。</p>
                                    <p>2. ユーザーは、アカウントを第三者へ貸与、譲渡または共有してはなりません。ただし、本サービスが認めるチーム利用の場合を除きます。</p>
                                    <p>3. アカウントによって行われた一切の操作は、当該ユーザー自身によるものとみなします。</p>
                                    <p>4. アカウントの不正利用を確認した場合、ユーザーは直ちに当社へ通知するものとします。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第12条（管理者の責任）</h3>
                                    <p>1. チーム機能を利用する場合、管理者はメンバーの登録、削除、権限設定その他の管理を自己の責任において行うものとします。</p>
                                    <p>2. メンバーによる本サービスの利用は、当該ユーザーによる利用とみなし、管理者およびユーザーはその責任を負うものとします。</p>
                                    <p>3. 管理者は、メンバーが本規約を遵守するよう必要かつ適切な措置を講じるものとします。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第13条（利用環境）</h3>
                                    <p>1. ユーザーは、本サービスの利用に必要な通信環境、コンピューター、ブラウザーその他の設備を自己の責任と費用で準備するものとします。</p>
                                    <p>2. 当社は、ユーザーの利用環境について動作保証を行うものではありません。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第14条（通知）</h3>
                                    <p>1. 当社からユーザーへの通知は、本サービス上への掲載、電子メールその他当社が適当と判断する方法により行います。</p>
                                    <p>2. 当社が登録された電子メールアドレス宛に通知を送信した時点、または本サービス上へ掲載した時点で、当該通知はユーザーへ到達したものとみなします。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第15条（権利義務の譲渡禁止）</h3>
                                    <p>1. ユーザーは、当社の事前の書面による承諾なく、本サービスに関する契約上の地位または本規約に基づく権利義務を第三者へ譲渡し、承継させ、担保に供し、その他処分してはならないものとします。</p>
                                    <p>2. 当社は、本サービスに関する事業を第三者へ譲渡した場合には、本サービスに関する契約上の地位、本規約に基づく権利義務およびユーザー情報を譲受人へ承継させることができるものとし、ユーザーはあらかじめこれに同意するものとします。</p>
                                </div>
                            </div>
                        </section>

                        {/* 第2章 サービスの利用 */}
                        <section>
                            <h2 className="text-2xl font-bold mb-6 pb-2 border-b-2 border-blue-600 text-gray-900">第2章 サービスの利用</h2>
                            
                            <div className="space-y-6">
                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第16条（利用許諾）</h3>
                                    <p>1. 当社は、ユーザーに対し、本規約に従うことを条件として、本サービスを日本国内において非独占的かつ譲渡不能な範囲で利用する権利を許諾します。</p>
                                    <p>2. ユーザーは、当社の事前の書面による承諾なく、本サービスの利用権を第三者へ譲渡し、貸与し、再許諾し、またはその他の方法で利用させてはならないものとします。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第17条（サービスの利用）</h3>
                                    <p>1. ユーザーは、本規約および当社が別途定める利用方法に従い、本サービスを利用するものとします。</p>
                                    <p>2. ユーザーは、本サービスを自己の業務のために利用するものとし、法令または公序良俗に反する目的で利用してはなりません。</p>
                                    <p>3. 当社は、ユーザーによる本サービスの利用状況に応じて、利用方法、利用可能な機能または利用条件を定めることがあります。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第18条（データの登録）</h3>
                                    <p>1. ユーザーは、自己の責任において本サービスへデータを登録するものとします。</p>
                                    <p>2. ユーザーは、登録するデータについて、正確性、完全性および適法性を保証するものとします。</p>
                                    <p>3. 当社は、登録されたデータの内容について確認または保証する義務を負いません。</p>
                                    <p>4. 法令違反または第三者の権利を侵害するデータを登録してはならないものとします。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第19条（データの管理）</h3>
                                    <p>1. ユーザーは、本サービスへ登録したデータについて、自ら管理する責任を負うものとします。</p>
                                    <p>2. 当社は、システム運営上必要がある場合、法令に基づく場合または本規約に違反すると判断した場合には、登録データの全部または一部を削除し、または利用を制限することがあります。</p>
                                    <p>3. 当社は、前項に基づく措置によりユーザーに生じた損害について、当社の故意または重大な過失がある場合を除き、責任を負いません。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第20条（知的財産権）</h3>
                                    <p>1. 本サービスに関する著作権、商標権その他一切の知的財産権は、当社または正当な権利者に帰属します。</p>
                                    <p>2. 本規約に基づく本サービスの利用許諾は、本サービスに関する知的財産権の譲渡または使用許諾を意味するものではありません。</p>
                                    <p>3. ユーザーは、本サービスを通じて取得した情報を、法令で認められる範囲を超えて利用してはなりません。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第21条（禁止事項）</h3>
                                    <p>ユーザーは、本サービスの利用にあたり、次の各号に掲げる行為を行ってはならないものとします。</p>
                                    <ul className="list-none space-y-1 ml-4">
                                        <li>1. 法令または公序良俗に反する行為</li>
                                        <li>2. 犯罪行為または犯罪に関連する行為</li>
                                        <li>3. 虚偽または不正確な情報を登録する行為</li>
                                        <li>4. 他者になりすまして本サービスを利用する行為</li>
                                        <li>5. 他人のアカウントを不正に利用する行為</li>
                                        <li>6. 本サービスまたは第三者のシステムに不正アクセスする行為</li>
                                        <li>7. 本サービスの運営を妨害する行為</li>
                                        <li>8. コンピューターウイルスその他有害なプログラムを送信または登録する行為</li>
                                        <li>9. 本サービスを不正な請求、詐欺その他違法な目的で利用する行為</li>
                                        <li>10. 第三者の知的財産権、プライバシーその他の権利を侵害する行為</li>
                                        <li>11. 本サービスをリバースエンジニアリング、解析または改変する行為</li>
                                        <li>12. 当社の承諾なく本サービスを再販売し、または第三者へ提供する行為</li>
                                        <li>13. その他、当社が不適切と判断する行為</li>
                                    </ul>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第22条（利用停止等）</h3>
                                    <p>1. 当社は、ユーザーが次の各号のいずれかに該当する場合には、事前の通知または催告なく、本サービスの全部または一部の利用を停止し、または利用契約を解除することができます。</p>
                                    <ul className="list-none space-y-1 ml-8">
                                        <li>(1) 本規約に違反した場合</li>
                                        <li>(2) 登録情報に虚偽があった場合</li>
                                        <li>(3) 利用料金の支払いを遅滞した場合</li>
                                        <li>(4) 本サービスの運営を妨げる行為を行った場合</li>
                                        <li>(5) その他、当社が利用継続を適当でないと判断した場合</li>
                                    </ul>
                                    <p className="mt-2">2. 前項の措置によりユーザーに損害が生じた場合であっても、当社は責任を負いません。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第23条（サービスの中断）</h3>
                                    <p>1. 当社は、次の各号のいずれかに該当する場合、本サービスの全部または一部を一時的に中断することがあります。</p>
                                    <ul className="list-none space-y-1 ml-8">
                                        <li>(1) システムの保守または点検を行う場合</li>
                                        <li>(2) システム障害が発生した場合</li>
                                        <li>(3) 災害、停電、通信障害その他不可抗力によりサービス提供が困難となった場合</li>
                                        <li>(4) その他、当社が必要と判断した場合</li>
                                    </ul>
                                    <p className="mt-2">2. 当社は、前項に基づくサービスの中断により生じた損害について、当社の故意または重大な過失がある場合を除き、責任を負いません。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第24条（サポートおよび保守）</h3>
                                    <p>1. 当社は、本サービスに関するサポートを、当社が別途定める方法および受付時間において提供します。</p>
                                    <p>2. サポートの内容、提供範囲および対応時間は、当社が別途定めるものとします。</p>
                                    <p>3. 当社は、ユーザー固有の業務、会計、税務、法務、外部サービスの設定、CSVデータの作成または修正その他これらに類する事項について、対応義務を負うものではありません。</p>
                                    <p>4. 当社は、本サービスの品質維持および改善のため、必要に応じて保守、更新または修正を行うことがあります。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第25条（サービス内容の変更）</h3>
                                    <p>1. 当社は、本サービスの全部または一部について、機能の追加、変更または廃止を行うことがあります。</p>
                                    <p>2. 前項の変更によりユーザーに損害が生じた場合であっても、当社の故意または重大な過失がある場合を除き、当社は責任を負いません。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第26条（サービスの終了）</h3>
                                    <p>1. 当社は、本サービスを終了する場合、原則として30日前までにユーザーへ通知します。</p>
                                    <p>2. 前項の通知は、本サービス上への掲載その他当社が適当と判断する方法により行います。</p>
                                    <p>3. 本サービスの終了に伴いユーザーに損害が生じた場合であっても、当社の故意または重大な過失がある場合を除き、当社は責任を負いません。</p>
                                </div>
                            </div>
                        </section>

                        {/* 第3章 利用料金・契約 */}
                        <section>
                            <h2 className="text-2xl font-bold mb-6 pb-2 border-b-2 border-blue-600 text-gray-900">第3章 利用料金・契約</h2>
                            
                            <div className="space-y-6">
                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第27条（利用料金）</h3>
                                    <p>1. ユーザーは、本サービスの利用にあたり、当社が別途定める料金表に基づき、初期費用、月額利用料、オプション利用料その他の利用料金（以下「利用料金」といいます。）を支払うものとします。</p>
                                    <p>2. 利用料金、課金方法、支払期日その他の条件は、当社が別途定めるものとする。</p>
                                    <p>3. 当社は、法令の改正、経済情勢の変動または本サービスの内容変更その他の理由により、利用料金を変更することがあります。</p>
                                    <p>4. 前項の場合、当社は変更予定日の30日前までに、ユーザーへ通知または本サービス上で公表するものとします。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第28条（支払方法）</h3>
                                    <p>1. ユーザーは、当社が指定する方法により利用料金を支払うものとします。</p>
                                    <p>2. 利用料金の支払いに必要な手数料その他の費用は、ユーザーの負担とします。</p>
                                    <p>3. ユーザーが支払期日までに利用料金を支払わない場合、当社は本サービスの全部または一部の利用を停止することがあります。</p>
                                    <p>4. ユーザーは、利用料金の支払いを遅滞した場合、支払期日の翌日から支払済みまで、年14.6％の割合による遅延損害金を支払うものとします。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第29条（プランの変更）</h3>
                                    <p>1. ユーザーは、当社所定の方法により利用プランの変更を申し込むことができます。</p>
                                    <p>2. プラン変更の適用時期は、当社が別途定めるものとします。</p>
                                    <p>3. プラン変更に伴う料金の計算方法については、当社が別途定めるものとします。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第30条（無料プランおよび無料期間）</h3>
                                    <p>1. 当社は、本サービスについて無料プランまたは無料利用期間を設ける場合があります。</p>
                                    <p>2. 無料プランまたは無料利用期間の提供条件は、当社が別途定めるものとします。</p>
                                    <p>3. 当社は、無料プランまたは無料利用期間の内容を変更または終了することがあります。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第31条（解約）</h3>
                                    <p>1. ユーザーは、当社所定の方法により、いつでも本サービスを解約することができます。</p>
                                    <p>2. 解約の効力発生日は、当社が別途定める基準によるものとします。</p>
                                    <p>3. 解約時点で発生している利用料金その他の債務は、解約後も消滅しません。</p>
                                    <p>4. 当社は、法令に別段の定めがある場合を除き、既に支払われた利用料金を返金しません。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第32条（契約終了後の取扱い）</h3>
                                    <p>1. 利用契約が終了した場合、ユーザーは本サービスを利用する権利を失います。</p>
                                    <p>2. 当社は、契約終了後、一定期間経過後にユーザーの登録情報および保存データを削除することがあります。</p>
                                    <p>3. 前項の保存期間および削除方法は、当社が別途定めるものとします。</p>
                                    <p>4. ユーザーは、契約終了までに必要なデータを自己の責任において保存するものとします。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第33条（利用契約の解除）</h3>
                                    <p>1. 当社は、ユーザーが次の各号のいずれかに該当する場合には、事前の通知または催告なく利用契約を解除することができます。</p>
                                    <ul className="list-none space-y-1 ml-8">
                                        <li>(1) 本規約に重大な違反をした場合</li>
                                        <li>(2) 利用料金の支払いを相当期間怠った場合</li>
                                        <li>(3) 差押え、仮差押え、仮処分、強制執行その他これらに準ずる手続が開始された場合</li>
                                        <li>(4) 破産手続開始、民事再生手続開始、会社更生手続開始または特別清算開始の申立てがあった場合</li>
                                        <li>(5) 支払停止または支払不能となった場合</li>
                                        <li>(6) 反社会的勢力との関係が判明した場合</li>
                                        <li>(7) その他、利用契約の継続が困難であると当社が合理的に判断した場合</li>
                                    </ul>
                                    <p className="mt-2">2. 前項に基づく解除によりユーザーに損害が生じた場合であっても、当社は責任を負いません。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第34条（未払債務）</h3>
                                    <p>1. 利用契約が終了した場合であっても、ユーザーは当社に対する未払債務の支払義務を免れるものではありません。</p>
                                    <p>2. 当社は、未払債務がある場合、法令の範囲内で必要な措置を講じることができます。</p>
                                    <p>3. ユーザーは、未払債務の回収に要した合理的な費用を負担する場合があります。</p>
                                </div>
                            </div>
                        </section>

                        {/* 第4章 データおよび外部サービス */}
                        <section>
                            <h2 className="text-2xl font-bold mb-6 pb-2 border-b-2 border-blue-600 text-gray-900">第4章 データおよび外部サービス</h2>
                            
                            <div className="space-y-6">
                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第35条（外部サービスとの連携）</h3>
                                    <p>1. 本サービスは、第三者が提供する外部サービスと連携して提供される場合があります。</p>
                                    <p>2. ユーザーは、外部サービスを利用する場合、当該サービス提供者が定める利用規約その他の条件に従うものとします。</p>
                                    <p>3. 外部サービスの障害、仕様変更、提供停止または終了により、本サービスの全部または一部が利用できなくなった場合であっても、当社の故意または重大な過失がある場合を除き、当社は責任を負わないものとします。</p>
                                    <p>4. 当社は、外部サービスとの連携内容を予告なく変更する場合があります。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第36条（ユーザーデータ）</h3>
                                    <p>1. ユーザーは、本サービスへ登録するデータについて、適法な権利を有していることを保証するものとします。</p>
                                    <p>2. ユーザーは、登録したデータについて、自らの責任において管理するものとします。</p>
                                    <p>3. 当社は、本サービスの提供、保守、障害対応、法令遵守その他サービス運営上必要な範囲で、登録データを利用できるものとします。</p>
                                    <p>4. 当社は、法令に基づく場合、本規約に違反すると判断した場合または本サービスの運営上必要がある場合には、ユーザーデータを閲覧、移動、複製または削除することがあります。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第37条（データの保存および削除）</h3>
                                    <p>1. 当社は、ユーザーが本サービスへ登録したデータについて、その保存期間を保証するものではありません。</p>
                                    <p>2. データの保存期間および削除基準は、当社が別途定めるものとします。</p>
                                    <p>3. ユーザーは、必要なデータについて、自らの責任でバックアップを取得するものとします。</p>
                                    <p>4. 契約終了後、当社は一定期間経過後にユーザーデータを削除することができます。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第38条（統計情報の利用）</h3>
                                    <p>1. 当社は、本サービスの利用状況その他ユーザーデータを、個人または特定のユーザーを識別できない形式に加工した統計情報として作成し、サービス改善、品質向上、障害分析、マーケティングその他本サービスの運営に必要な目的で利用できるものとします。</p>
                                    <p>2. 前項の統計情報については、ユーザーの営業秘密または個人情報は含まれないものとします。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第39条（ベータ機能等）</h3>
                                    <p>1. 当社は、試験提供中の機能（以下「ベータ機能」といいます。）を提供する場合があります。</p>
                                    <p>2. ベータ機能は、正式版と比較して不具合、仕様変更または提供終了が生じる場合があります。</p>
                                    <p>3. 当社は、ベータ機能について品質、継続性または特定目的への適合性を保証しません。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第40条（フィードバック）</h3>
                                    <p>1. ユーザーが当社へ提供した要望、提案、改善案その他のフィードバックについて、当社は無償で利用できるものとします。</p>
                                    <p>2. 当社は、前項のフィードバックを利用することについて、ユーザーへの対価の支払いその他の義務を負いません。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第41条（電子的手段による同意）</h3>
                                    <p>1. ユーザーは、本サービスの利用契約、各種通知、利用規約への同意その他本サービスに関する手続が電子的方法により行われることに同意するものとします。</p>
                                    <p>2. 電子的に行われた承諾、通知または同意は、書面によるものと同等の法的効力を有するものとします。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第42条（請求処理に関する責任）</h3>
                                    <p>1. ユーザーは、本サービスを利用して登録または送信する請求先情報、請求内容、請求金額、税区分、支払期限その他一切の請求データについて、自らの責任において作成、確認および管理するものとします。</p>
                                    <p>2. 当社は、ユーザーが登録または送信した請求データの正確性、完全性、適法性または税務上の適合性について確認、修正または保証する義務を負いません。</p>
                                    <p>3. 本サービスは、ユーザーが登録した請求データを外部サービスへ連携するためのシステムであり、請求内容の正確性、請求書の法的有効性、税務処理その他請求業務の適法性を保証するものではありません。</p>
                                    <p>4. ユーザーは、本サービスを利用して請求処理を行う前に、必要な内容を自己の責任において確認するものとします。</p>
                                    <p>5. 外部サービスにおいて請求書の作成、送信、決済またはその他の処理が行われたことによりユーザーまたは第三者に生じた損害について、当社の故意または重大な過失がある場合を除き、当社は責任を負いません。</p>
                                    <p>6. 法令の改正、税制度の変更または外部サービスの仕様変更等により請求処理へ影響が生じた場合であっても、当社は速やかな対応に努めるものとしますが、対応完了までに生じた損害について責任を負わないものとします。</p>
                                </div>
                            </div>
                        </section>

                        {/* 第5章 免責・その他 */}
                        <section>
                            <h2 className="text-2xl font-bold mb-6 pb-2 border-b-2 border-blue-600 text-gray-900">第5章 免責・その他</h2>
                            
                            <div className="space-y-6">
                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第43条（保証の否認）</h3>
                                    <p>1. 当社は、本サービスについて、特定の目的への適合性、有用性、正確性、完全性、継続性、可用性または安全性を保証するものではありません。</p>
                                    <p>2. 当社は、本サービスにより作成、送信または管理されるデータについて、その正確性、完全性または適法性を保証するものではありません。</p>
                                    <p>3. 当社は、本サービスがすべての利用環境において正常に動作することを保証するものではありません。</p>
                                    <p>4. 本サービスは、外部サービスとの連携を前提とする機能を含む場合がありますが、当該外部サービスの仕様変更、停止または終了により生じた影響について、当社は責任を負わないものとします。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第44条（免責事項）</h3>
                                    <p>1. 当社は、当社の故意または重大な過失による場合を除き、本サービスの利用または利用不能によりユーザーまたは第三者に生じた損害について責任を負わないものとします。</p>
                                    <p>2. 当社は、天災地変、停電、通信障害、第三者サービスの障害その他当社の責めに帰することができない事由により生じた損害について責任を負いません。</p>
                                    <p>3. ユーザーが登録したデータの誤り、不備または不正確な内容に起因して生じた損害について、当社は責任を負いません。</p>
                                    <p>4. ユーザーと第三者との間で生じた紛争については、当事者間で解決するものとし、当社は責任を負いません。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第45条（損害賠償）</h3>
                                    <p>1. 当社がユーザーに対して損害賠償責任を負う場合であっても、当社の故意または重大な過失による場合を除き、その賠償範囲は通常かつ直接の損害に限られるものとします。</p>
                                    <p>2. 当社の損害賠償額は、当該損害が発生した月を含む直近1か月間にユーザーが当社へ現実に支払った利用料金を上限とします。</p>
                                    <p>3. 当社は、逸失利益、間接損害、特別損害または第三者からの請求に起因する損害について責任を負いません。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第46条（個人情報の取扱い）</h3>
                                    <p>1. 当社は、ユーザーの個人情報を、当社が別途定めるプライバシーポリシーに従って適切に取り扱います。</p>
                                    <p>2. ユーザーは、本サービスの提供に必要な範囲で、当社が個人情報を利用することに同意するものとします。</p>
                                    <p>3. 当社は、法令に基づく場合を除き、ユーザーの同意なく個人情報を第三者へ提供しません。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第47条（秘密保持）</h3>
                                    <p>1. ユーザーおよび当社は、本サービスの利用または提供に関連して知り得た相手方の技術上、営業上その他一切の非公知情報を、相手方の事前の承諾なく第三者へ開示または漏えいしてはならないものとします。</p>
                                    <p>2. 前項の規定は、次の各号のいずれかに該当する情報については適用しません。</p>
                                    <ul className="list-none space-y-1 ml-8">
                                        <li>(1) 開示時に既に公知であった情報</li>
                                        <li>(2) 開示後、自己の責めによらず公知となった情報</li>
                                        <li>(3) 正当な権限を有する第三者から適法に取得した情報</li>
                                        <li>(4) 法令または裁判所その他公的機関により開示を求められた情報</li>
                                    </ul>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第48条（反社会的勢力の排除）</h3>
                                    <p>1. ユーザーは、自らおよびその役員または実質的支配者が反社会的勢力に該当しないこと、および将来にわたって該当しないことを表明し保証するものとします。</p>
                                    <p>2. ユーザーは、反社会的勢力を利用し、資金提供を行い、またはこれらに関与する行為を行わないものとします。</p>
                                    <p>3. 当社は、ユーザーが本条に違反した場合には、何らの催告を要することなく利用契約を解除することができます。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第49条（分離可能性）</h3>
                                    <p>本規約のいずれかの条項またはその一部が法令等により無効または執行不能と判断された場合であっても、その他の条項は引き続き有効に存続するものとします。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第50条（存続条項）</h3>
                                    <p>本サービスの利用契約が終了した場合であっても、次の各条項は、その性質上存続すべきものとして、引き続き有効に存続するものとします。</p>
                                    <p>第6条（取引実績等の掲載）、第20条（知的財産権）、第34条（未払債務）、第36条（ユーザーデータ）、第37条（データの保存および削除）、第38条（統計情報の利用）、第40条（フィードバック）、第41条（電子的手段による同意）、第42条（請求処理に関する責任）、第43条（保証の否認）、第44条（免責事項）、第45条（損害賠償）、第46条（個人情報の取扱い）、第47条（秘密保持）、第48条（反社会的勢力の排除）、第51条（準拠法）、第52条（協議および合意管轄）</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第51条（準拠法）</h3>
                                    <p>本規約の成立、効力、解釈および履行については、日本法を準拠法とします。</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold mb-2 text-gray-800">第52条（協議および合意管轄）</h3>
                                    <p>1. 本規約または本サービスに関して疑義または紛戦が生じた場合、当社およびユーザーは誠意をもって協議し、その解決を図るものとします。</p>
                                    <p>2. 前項の協議によっても解決しない場合には、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</p>
                                </div>
                            </div>
                        </section>
                    </div>

                    <div className="mt-12 pt-8 border-t border-gray-200">
                        <p className="text-lg font-bold text-gray-900">附則</p>
                        <p className="text-gray-700 mt-2">本規約は規約は2026年8月25日に制定され、発効し、かつ実施されるものとします。</p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Terms;
